export default __webpack_public_path__ + "static/media/file.3803626d.svg";